@if (item(); as item) {
  <div class="tt-guideline-search-result-item_icon">
    <mat-icon
      [icon]="matchingFieldIconMap | getFromMap: item.matchingField : 'book'"
      [iconSize]="24"
      [ttTooltip]="iconTooltipTranslationKeyMap | getFromMap: item.matchingField : 'Guideline' | transloco" />
  </div>

  <div class="tt-guideline-search-result-item_content">
    <h3 class="tt-guideline-search-result-item_title">{{ item.title }}</h3>
    @if (item.navigationPath) {
      <div
        class="tt-guideline-search-result-item-path"
        [ttTooltip]="pathTooltipTranslationKeyMap | getFromMap: item.matchingField : 'GoToGuideline' | transloco"
        (click)="emitPathClicked($event)">
        {{ item.navigationPath }}
      </div>
    }
    <div class="tt-guideline-search-result-item_meta">
      <span class="tt-guideline-search-result-item_meta-snippet" [innerHTML]="item.snippet"></span>
    </div>

    <div class="tt-guideline-search-result-item_organisation">
      <span class="tt-guideline-search-result-item_organisation-label">{{ 'Organisation' | transloco }}:</span>
      {{ item.organizationDisplayName }}
    </div>
  </div>
}
